export enum ScoreKind {
  Pass = 'pass',
  Fail = 'fail',
  None = 'none',
}

export enum ScoreKey {
  Score = 'score',
  MessageAdherence = 'messageAdherence',
  ScoreSkills = 'scoreSkills',
  ScoreCustomized = 'scoreCustomized',
  MessageAdherenceV2 = 'messageAdherenceV2',
}

export enum PromptTypesKeyMapping {
  SCORE_OVERALL = 'SCORE_OVERALL',
  MESSAGE_ADHERENCE = 'MESSAGE_ADHERENCE',
  SCORE_SKILLS = 'SCORE_SKILLS',
  SCORE_CUSTOMIZED = 'SCORE_CUSTOMIZED',
  MESSAGE_ADHERENCE_V2 = 'MESSAGE_ADHERENCE_V2',
  ACCURACY_CLAIM_VERIFICATION = 'ACCURACY_CLAIM_VERIFICATION',
}

export interface ScoreEntry {
  key: ScoreKey;
  label: string;
  value: number;
  weight: number;
}

// Use `Score` as the type for your score array item.  This is what the qai-scores-list component expects.
export type ScoreArrayItem = {
  label: string;
  description?: string;
  value: string; // Note: It's a STRING!
  max: string;
  kind: ScoreKind; // Use your enum here
  labelKey?: string; // Optional, for translated labels
};

export enum PracticeType {
  PRACTICE = 'PRACTICE',
  CERTIFICATION = 'CERTIFICATION',
  PATHWAY = 'PATHWAY',
}

export enum TabName {
  OverallScore = 'Overall Score',
  MessageAdherence = 'Message Adherence',
  Objectives = 'Objectives',
  Skills = 'Skills',
}

export const ResultHeadersDynamicTextConstants = {
  GREAT_JOB_PRACTICED: (count: number) =>
    `Great job, you've practiced ${count} ${count === 1 ? 'time' : 'times'}. Keep going!`,
  REVIEW_FEEDBACK_KEEP_PRACTICING: 'Review your feedback and keep practicing',
  HIGH_PERFORMERS_PRACTICE: 'High performers practice at least once a week',
  SUCCESSFULLY_PASSED: 'Great job! You successfully passed this call.',
  DIDNT_REACH_PASSING_SCORE:
    "You didn't reach the passing score for this call.",
  OUT_OF_ATTEMPTS:
    '<b>You are out of attempts.</b> Review your feedback to learn how you can improve.',
  REVIEW_FEEDBACK_THEN_RETURN:
    'Review your feedback, then return home when you are ready.',
};

export interface ResultHeaderDynamicText {
  h1: string;
  h2: string;
}
